import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23, 47, 32);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-urgencyRed text-white w-full" data-id="element-328">
      <div className="max-w-7xl mx-auto px-4 min-h-[48px] md:h-12 flex items-center justify-center py-2 md:py-0" data-id="element-329">
        <div className="flex items-center justify-center text-center flex-wrap gap-x-2 gap-y-1 text-xs md:text-sm font-medium" data-id="element-330">
          <motion.span animate={{
          opacity: [1, 0.5, 1]
        }} transition={{
          repeat: Infinity,
          duration: 1.5
        }} className="text-yellow-300" data-id="element-331">
            ⚡
          </motion.span>

          <span data-id="element-332">OFERTA DE LANZAMIENTO: Solo por las próximas 24 horas</span>
          <span className="hidden md:inline" data-id="element-333">•</span>
          <span data-id="element-334">Precio sube a $27 USD</span>
          <span className="hidden md:inline" data-id="element-335">•</span>

          <span className="font-mono font-bold bg-black/20 px-2 py-0.5 rounded" data-id="element-336">
            [{hours}:{minutes}:{seconds}]
          </span>

          <motion.span animate={{
          opacity: [1, 0.5, 1]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          delay: 0.75
        }} className="text-yellow-300" data-id="element-337">
            ⚡
          </motion.span>
        </div>
      </div>
    </div>;
}